import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Party } from '../../@posturinn/client-react';
import { getRecipients } from '../../actions/registerShipmentActions';

const useRecipients = userProfile => {
	const dispatch = useDispatch<any>();
	const {
		recipients,
		recipientsError,
		recipientsLoading,
	}: { recipients: Party[]; recipientsError: boolean; recipientsLoading: boolean } = useSelector(
		({ recipientsReducer }) => recipientsReducer
	);
	useEffect(() => {
		if (userProfile && recipients === null && !recipientsError && !recipientsLoading) {
			dispatch(getRecipients(userProfile.userId));
		}
	}, [userProfile, recipients, recipientsError, recipientsLoading, dispatch]);
	return {
		recipients,
		recipientsError,
		recipientsLoading,
	};
};

export default useRecipients;
